import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ObservableInput } from 'ngx-observable-input';
import { Observable } from 'rxjs';
import { Single } from '../../interfaces/single.interface';



/**
 * @title Table that uses the recycle view repeater strategy.
 */
@Component({
  selector: 'leaderboard',
  styleUrls: ['leaderboard.component.css'],
  templateUrl: 'leaderboard.component.html',
})
export class LeaderboardComponent {
  displayedColumns: string[] = ['position', 'name', 'value'];


  @ObservableInput()
  @Input("results")
  results$: Observable<Single[]>;

  @Output()
  select: EventEmitter<any> = new EventEmitter<any>();

  onClick(row) {
    this.select.emit(row);
  }
}


/**  Copyright 2022 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at https://angular.io/license */
